// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"369c9c9a","93":"3354830f","119":"151584e1","178":"a7ba7721","240":"cddcc37b","381":"0de4664a","530":"cf0dad2c","752":"2602867d","795":"65421067","815":"80b08828","845":"973db92a","884":"9d519dcf"}[chunkId] + ".chunk.js";
};